import PropTypes from 'prop-types';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { List, Collapse } from '@mui/material';
//
import { NavItemRoot, NavItemSub } from './NavItem';
import { getActive } from '..';
/* import {
  ListItemStyle as ListItem,
  ListItemTextStyle,
  ListItemIconStyle,
} from './style'; */
import Iconify from '../../Iconify';

// ----------------------------------------------------------------------

NavListRoot.propTypes = {
  list: PropTypes.object,
  isCollapse: PropTypes.bool,
};

export function NavListRoot({ list, isCollapse }) {
  const { pathname } = useLocation();

  const active = getActive(list.path, pathname);

  const [open, setOpen] = useState(active);

  const hasChildren = (list.children ?? []).length > 0;

  if (list.children.length === 0) {
    return (
      <>
        {/* <ListItem>
          <>
            {list.icon && <ListItemIconStyle>{list.icon}</ListItemIconStyle>}
            <ListItemTextStyle
              disableTypography
              primary={list.title}
              isCollapse={isCollapse}
            />
            {!isCollapse && (
              <>
                {list.info && list.info}
                {hasChildren && <ArrowIcon open={open} />}
              </>
            )}
          </>
        </ListItem> */}
      </>
    );
  }
  if (hasChildren) {
    return (
      <>
        {list.route ? (
          <>
            <NavItemRoot
              item={list}
              isCollapse={isCollapse}
              active={pathname.includes(list.route)}
              open={open}
              onOpen={() => setOpen(!open)}
            />
          </>
        ) : (
          <NavItemRoot
            item={list}
            isCollapse={isCollapse}
            active={active}
            open={open}
            onOpen={() => setOpen(!open)}
          />
        )}

        {!isCollapse && (
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {(list.children || []).map((item) => (
                <NavListSub key={item.title + item.path} list={item} />
              ))}
            </List>
          </Collapse>
        )}
      </>
    );
  }

  return <NavItemRoot item={list} active={active} isCollapse={isCollapse} />;
}

// ----------------------------------------------------------------------

NavListSub.propTypes = {
  list: PropTypes.object,
};

function NavListSub({ list }) {
  const { pathname } = useLocation();

  const active = getActive(list.path, pathname);

  const [open, setOpen] = useState(active);

  const hasChildren = list.children;

  if (hasChildren) {
    return (
      <>
        <NavItemSub
          item={list}
          onOpen={() => setOpen(!open)}
          open={open}
          active={active}
        />

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 3 }}>
            {(list.children || []).map((item) => (
              <NavItemSub
                key={item.title + item.path}
                item={item}
                active={getActive(item.path, pathname)}
              />
            ))}
          </List>
        </Collapse>
      </>
    );
  }

  return <NavItemSub item={list} active={active} />;
}

ArrowIcon.propTypes = {
  open: PropTypes.bool,
};

export function ArrowIcon({ open }) {
  return (
    <Iconify
      icon={open ? 'eva:arrow-ios-downward-fill' : 'eva:arrow-ios-forward-fill'}
      sx={{ width: 16, height: 16, ml: 1 }}
    />
  );
}
